import { render, staticRenderFns } from "./FIFDirectToReset.vue?vue&type=template&id=18a01d12&"
import script from "./FIFDirectToReset.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FIFDirectToReset.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FIFDirectToReset.vue?vue&type=style&index=0&id=18a01d12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports